import ToastHighLighter from '@/lib/ToastHighLighter';

export const LoginFormCode = () => {
  const language = 'html';
  const codeString = `
  // Login form
  ...
  <nav class="navbar navbar-expand-lg" role="navigation">
    <a href="/" class="navbar-brand">
      <img
        src=""
        alt="FHNW - Fachhochschule Nordwestschweiz"
        height=""
        width=""
      />
      <span class="navbar-title">Projekttitel</span>
    </a>      
    <span class="navbar-title d-sm-none">Projekttitel</span>
  </nav>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-7 mx-auto">
        <form>
          <h2>Login</h2>
          <div class="form-floating">
            <input
              type="email"
              class="form-control"
              id="floatingInput"
              placeholder="name@example.com"
            />
            <label for="floatingInput">Email address</label>
          </div>
          <div class="form-floating mt-3">
            <input
              type="password"
              class="form-control"
              id="floatingPassword"
              placeholder="Password"
            />
            <label for="floatingPassword">Password</label>
          </div>
          <div class="form-check text-start my-3">
            <input
              class="form-check-input"
              type="checkbox"
              value="remember-me"
              id="flexCheckDefault"
            />
            <label class="form-check-label" for="flexCheckDefault">
              Remember me
            </label>
          </div>
          <div class="d-flex justify-content-start gap-2 mt-5">
            <button class="btn btn-secondary" type="submit">
              Sign in
            </button>
            <button class="btn btn-light" type="reset">
              Reset
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <footer id="footer">
    <div class="container tools__footer pt-4">
      <div class="row">
        <div class="d-flex justify-content-center">
          <p>
            <a href="https://www.fhnw.ch" target="_blank">
              www.fhnw.ch
            </a>
            <span class="d-inline-block mx-1 mx-md-2">|</span>
            <a href="#">Impressum</a>
            <span class="d-inline-block mx-1 mx-md-2">|</span>
            <a href="#">Datenschutz</a>
          </p>
        </div>
      </div>
    </div>
  </footer>
  ...
`;

  return (
    <>
      <ToastHighLighter
        name={'loginform'}
        codeString={codeString}
        language={language}
        show={false}
      />
    </>
  );
};
